export const BI = {
  ENDPOINT: 'form-builder',
  ERROR_ENDPOINT: 'form-builder',
  SRC: 5,
}
